import React from 'react'
import { Box, InputLabel, TextField, Typography } from '@material-ui/core';
import { cpfMask } from '../../helpers/Masks/CpfMask';
import { cnpjMask } from '../../helpers/Masks/CNPJMask';
import { cepMask } from '../../helpers/Masks/CEPMask';
import { telefoneMask } from '../../helpers/Masks/TelefoneMask';
import { celularMask } from '../../helpers/Masks/CelularMask';
import { numericoMask } from '../../helpers/Masks/NumericoMask';

interface InputProps {
    label: string;
    name: string;
    placeholder: string;
    value: string;
    maxLength?: number;
    type?: InputType;
    rows?: number;
    multiline?: boolean;
    question?: boolean;
    mandatory?: boolean;
    error: any;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}

export enum InputType {
    CPF,
    TELEFONE,
    CELULAR,
    CNPJ,
    CEP,
    NUMERICO,
    SENHA
}


export default function Input(props: InputProps) {

    const {
        name,
        label,
        value,
        error = null,
        maxLength = null,
        placeholder = null,
        type = null,
        multiline = null,
        rows = null,
        question = null,
        mandatory = null,
        onChange,
        onBlur
    } = props;

    const handleInputChange = (e: any) => {
        if (maxLength != null && maxLength > 0) {
            e.target.value = e.target.value.toString().slice(0, maxLength)
        }

        if (type != null) {
            e.target.value = setTypeConfig(e, type)
        }

        onChange(e);
    };

    const handleInputChangeBlur = (e: any) => {
        if (onBlur) {
            if (maxLength != null && maxLength > 0) {
                e.target.value = e.target.value.toString().slice(0, maxLength)
            }

            if (type != null) {
                e.target.value = setTypeConfig(e, type)
            }

            onBlur(e);
        }
    };

    return (
        <React.Fragment>

            <InputLabel {...(error && { error: true })} style={{ "color": (!error ? '#000' : '') }}>{label}{mandatory ? " *" : ""}</InputLabel>

            <Box mt={1}>

                {question ?
                    <Box mt={2}>
                        <Typography style={{ "color": "#a5a3a3" }}>
                            Resposta:
                        </Typography>
                    </Box>
                    : ""}

                <TextField
                    variant={"standard"}
                    name={name}
                    rows={rows}
                    multiline={multiline}
                    fullWidth
                    placeholder={placeholder}
                    value={value}
                    onChange={handleInputChange}
                    onBlur={handleInputChangeBlur}
                    {...(error && { error: true, helperText: error })}>
                </TextField>
            </Box>
        </React.Fragment>
    )
}

function setTypeConfig(e: any, type: InputType): any {
    switch (type) {
        case InputType.CPF:
            cpfMask(e)
            break;
        case InputType.TELEFONE:
            telefoneMask(e)
            break;
        case InputType.CELULAR:
            celularMask(e)
            break;
        case InputType.CNPJ:
            cnpjMask(e)
            break;
        case InputType.CEP:
            cepMask(e)
            break;
        case InputType.NUMERICO:
            numericoMask(e)
            break;

        default:
            break;
    }

    return e.target.value;
}


